"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const DeniedMessage = () => {
    return ((0, jsx_runtime_1.jsx)("div", { className: "declined-container", children: (0, jsx_runtime_1.jsx)("div", { className: "content text-center", children: (0, jsx_runtime_1.jsxs)("div", { className: "pad-y-100", children: [(0, jsx_runtime_1.jsx)("h1", { className: "first-title", children: "Application Denied" }), (0, jsx_runtime_1.jsx)("p", { className: "first-subtitle", children: "Unfortunately, your application was not approved at this time. You will be sent an adverse action letter explaining our decision within the next 30 days." })] }) }) }));
};
exports.default = DeniedMessage;
